angular.module('routes.documentation.DocumentationController', [
  'stack'
])

/**
 * The DocumentationController manages view logic rendered to the
 * documentation.html template for the /documentation documentation.
 *
 * @class DocumentationController
 * @constructor
 * @module routes.documentation.DocumentationController
 */
.controller('DocumentationController', [
  '$scope',
  'constants',
  function ($scope, constants) {
    'use strict';

    /**
     * Property houses controller namespace.
     *
     * @property documentation
     * @type {Object}
     */
    $scope.documentation = {
      constants: {}
    };

    /**
     * Method copies resolved constants into the controller
     * namespace during the initalization process.
     *
     * @private
     */
    function defineConstants() {
      var documentation = $scope.documentation;
      $scope.documentation = angular.extend(documentation, constants);
    }


    /**
     * Method executes the initialization process.
     *
     * @private
     */
    function initialize() {
      defineConstants();
    }
    initialize();
  }
]);
